export enum ContactTypeEnum {
  CONTACT= 'CONTACT',
  EMPLOYEE= 'EMPLOYEE',
}
